// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"35a92b9a","553":"84a0d80f","722":"1b559737"}[chunkId] + ".chunk.js";
};